import React from "react";
import { observer } from "mobx-react-lite";


const CalendarInvitation = observer((props) => {
  const { settings, environment } = props;

  const { texts } = settings;

  return (
    
    // <div className="wrap" style={{ display: "flex" }}>
      <a href={`./api/calendar/geticalfile/${settings.invitationId}`} download={"invitation.ical"}>
      <button className="cms-button">
        {texts[environment.lang]}
        </button>
      </a>
    // </div>
  );
});

export default CalendarInvitation
